import { Link } from "react-router-dom";
import { useTenant } from "../../contexts/TenantContext";

interface NavLinksProps {
  onMobileClick?: () => void;
  isMobile?: boolean;
}

export const NavLinks = ({
  onMobileClick,
  isMobile = false,
}: NavLinksProps) => {
  const { config } = useTenant();

  if (!config) return null;

  const links = [
    { to: "/search", label: "Buy" },
    { to: "/valuation", label: "Sell" },
  ];

  if (isMobile) {
    return (
      <>
        {links.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            className="block px-3 py-2 rounded-md text-sm font-medium"
            style={{
              color: config.branding.colors.primary,
            }}
            onClick={onMobileClick}
          >
            {link.label}
          </Link>
        ))}
      </>
    );
  }

  return (
    <>
      {links.map((link) => (
        <Link
          key={link.to}
          to={link.to}
          className="px-4 py-2 rounded-lg text-sm font-medium nav-link"
          style={{
            color: config.branding.colors.primary,
            transition: "all 0.2s",
          }}
        >
          {link.label}
        </Link>
      ))}
    </>
  );
};

export default NavLinks;
